// extracted by mini-css-extract-plugin
export default {"form":"ApplyForm_form__gi1g+"};